<template>
  <div id="app">
    <v-app id="inspire">
      <div>
        <v-toolbar flat color="white">
          <v-toolbar-title>Posição Fiscal</v-toolbar-title>
          <v-divider
            class="mx-2"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <!---<v-combobox
              v-if="esconder"
              v-model="search"
              :items="empresas"
              placeholder="Pesquise por empresa"
              hide-no-data
              hide-selected
              item-text="nome"
              item-value="id"
              return-object
              :search-input.sync="searchEmpresa"
              append-icon="search"
              @change="getPesquisa"
            ></v-combobox>-->
           <v-spacer></v-spacer>
          <v-btn v-if="esconder" color="primary" dark class="mb-2" @click="create()">Novo</v-btn>
        </v-toolbar>
      </div>
      <v-data-table
        v-if="esconder"
        :headers="headers"
        :items="rows"
        class="elevation-1"
        :loading="loading"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.empresas_id.nome }}</td>
          <td class="text-xs-left">{{ props.item.nome }}</td>
          <td>{{ props.item.codigo }}</td>
          <td class="justify-center layout px-0">
            <v-icon
              small
              class="mr-2"
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
          </td>
        </template>
      </v-data-table>
      <div class="text-xs-center pa-3">
        <div class="text-center pa-2">
          <v-progress-circular
            v-if="mostrar"
            :indeterminate="indeterminate"
            :size="200"
            :width="3"
            color="light-blue"
          >Espere terminar de carregar...</v-progress-circular>
        </div>
        <paginate
          v-if="esconder"
          :page-count="total"
          :page-range="10"
          :page-link-class="'texto'"
          :margin-pages="2"
          :click-handler="getData"
          :prev-text="'Anterior'"
          :next-text="'Próxima'"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :active-class="'ativa'">
        </paginate>
      </div>
    </v-app>
  </div>
</template>


<script>
    import {sharedService} from '../services'

    export default {
      name: 'PosicaoFiscal',
      data() {
        return {
          selected: [],
          empresas: [],
          search: '',
          searchEmpresa: '',
          loading: false,
          rows: [],
          total: 0,
          filtros: '',
          headers: [
          {
            text: 'Empresa',
            align: 'left',
            value: 'empresa_id'
          },
          {text: 'Nome', value: 'nome'},
          {text: 'Código', value: 'codigo'}
          ],
          text: '',
          indeterminate: false,
          esconder: false,
          mostrar: false,
          empresaTes: ''
        }
      },
      computed:{
        empresa: function () {
          let self = this
          self.empresaTes = this.$store.getters.getEmpresa
          return this.$store.getters.getEmpresa
        }
      },
      methods: {
        getTotal: async function(numTotal){
          let self = this
          this.mostrar = true
          this.indeterminate = true
          this.esconder = false
          if(numTotal && numTotal > 0){
            let totalItens = numTotal/10
            if(Number.isInteger(totalItens) === true){
              self.total = totalItens
              self.mostrar = false
              self.indeterminate = false
              self.esconder = true
            } else {
              self.total = parseInt(totalItens.toFixed(1)) + 1
              self.mostrar = false
              self.indeterminate = false
              self.esconder = true
            }
          } else {
            sharedService.read('PosicaoFiscal?filtros=[["empresas_id","=","'+self.empresaTes.id+'"]]').then(function (obj){
              let totalItens = obj.total_records/10
              if(Number.isInteger(totalItens) === true){
                self.total = totalItens
                self.mostrar = false
                self.indeterminate = false
                self.esconder = true
              } else {
                self.total = parseInt(totalItens.toFixed(1)) + 1
                self.mostrar = false
                self.indeterminate = false
                self.esconder = true
              }
            })
          }
        },
        getData: async function (pageNum) {
          let self = this
          this.loading = true
          if(!this.filtros){
            if(pageNum === undefined){
              await sharedService.read('PosicaoFiscal?limit=10&page=1&filtros=[["empresas_id","=","'+self.empresaTes.id+'"]]').then(function (obj){
                self.rows = obj.obj
                self.loading = false
              })
            } else {
              await sharedService.read('PosicaoFiscal?limit=10&page='+pageNum+'&filtros=[["empresas_id","=","'+self.empresaTes.id+'"]]').then(function (obj){
                self.rows = obj.obj
                self.loading = false
              })
            }
          } /* if(this.filtros){
            if(pageNum === undefined || pageNum === '0'){
              await sharedService.read('PosicaoFiscal?limit=10&page=1&'+this.filtros).then(function (obj){
                self.rows = obj.obj
                self.loading = false
              })
            } else {
              await sharedService.read('PosicaoFiscal?limit=10&page='+pageNum+'&'+this.filtros).then(function (obj){
                self.rows = obj.obj
                self.loading = false
              })
            }
          }*/
        },
        /*getEmpresas: async function () {
          let self = this
          await sharedService.read('Empresas').then(function (obj){
              for (var key in obj.obj) {
                  let obje = {
                    id: obj.obj[key].id,
                    nome: obj.obj[key].nome_fantasia
                  }
                  self.empresas.push(obje)
              }
          })
        },
        getPesquisa: async function(){
          let self = this
          this.loading = true
          if(self.search !== ''){
            await sharedService.read('PosicaoFiscal?filtros=[["empresas_id","=","'+self.search.id+'"]]').then(function (obj){
              self.getTotal(obj.total_records)
              self.filtros = 'filtros=[["empresas_id","=","'+self.search.id+'"]]'
              self.getData('0')
            })
          } else {
            self.filtros = ''
            self.getTotal()
            self.getData()
          }
        },*/
        create() {
            this.$router.push({
                name: 'PosicaoFiscalForm'
            })
        },
        editItem (item) {
          this.$router.push({
            name: 'PosicaoFiscalEdit',
            params: {id: item.id}
          })
        },
        async deleteItem (item){
          let self = this

          this.$confirm('Tem certeza que deseja deletar este item?').then(res => {
            if (res) {
              sharedService._delete('PosicaoFiscal',item.id).then(function (obj){
                obj.text().then(function (text){
                  self.mostrar = text
                  if(obj.status === 200){
                      self.$store.dispatch('success', 'Posição Fiscal excluido com sucesso!')
                  }  else {
                      self.$store.dispatch('error', text)
                  }
                })
                self.getTotal()
                self.getData()
              })
              
            } else {
                this.close()
            }
          })
        }
      },
      /*watch: {
        searchEmpresa (val) {
          let self = this

          let busca
          if(val === null || val === ''){
              busca = 'limit=10'
          } else {
              busca = 'filtros=[["nome_fantasia","like","'+val+'%"]]'
          }

          sharedService.read('Empresas?'+busca).then(function (obj){
            self.empresas = []
            for (var key in obj.obj) {
              let obje = {
                id: obj.obj[key].id,
                nome: obj.obj[key].nome_fantasia
              }
              self.empresas.push(obje)
            }
          })
        }
      },*/
      watch:{
        empresa: function () {
          if(this.empresa){
            this.empresaTes = this.empresa
            this.getTotal()
            this.getData()
          }
        }
      },
      beforeMount() {
        this.getTotal()
        this.getData()
      }
    }
</script>

<style>
  .pagination {
    list-style-type: none;
  }
  .page-item {
    border: solid 1px #eeeeee ;
    background: #f5f5f5;
    font-size:15px;
    padding:13px 16px;
    display: inline-block;
  }
  .ativa{
    background: #bdbdbd   ;
    border: solid 1px #bdbdbd  ;
  }

  .texto{
    color: #424242 ;
  }
  
</style>
